<h1 mat-dialog-title>Map Layers Preview</h1>

<mat-dialog-content>
    <div class="map-container">
        <div #map class="map"></div>
		@if (loaded) {
			<div>
				@for (mapLayer of mapLayers; track $index) {
					<mat-checkbox [(ngModel)]="mapLayer.checked"
								  (ngModelChange)="toggleMapLayer(mapLayer)"
								  [ngModelOptions]="{standalone: true}"
								  [disabled]="mapLayer.disabledOnPreview"
								  class="layer-control"
					>
						{{ mapLayer.name }}
					</mat-checkbox>
				}
			</div>
		}
		@if (errors.length > 0) {
			<div>
				@for (error of errors; track $index) {
					<span>{{ error }}</span>
				}
			</div>
		}
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>
        Close
    </button>
</mat-dialog-actions>
